import { get, set } from "lodash"
import PropTypes from "prop-types"
import React from "react"
import { compose, lifecycle, withHandlers, withState } from "recompose"
import { Button } from "semantic-ui-react"
import styled from "styled-components"

const ScrollUpButton = ({ isVisible, onClick }) => (
	<StickyContainer isVisible={isVisible}>
		<Button circular color="orange" icon="arrow up" onClick={onClick} size="big" />
	</StickyContainer>
)

ScrollUpButton.propTypes = {
	elementRef: PropTypes.instanceOf(Element),
	isVisible: PropTypes.bool,
	onClick: PropTypes.func.isRequired
}

const StickyContainer = styled.div`
	&& {
		bottom: 30px;
		opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
		position: fixed;
		right: 30px;
		transition: visibility 0s ${({ isVisible }) => (isVisible ? "" : " 0.6s")}, opacity 0.6s;
		visibility: ${({ isVisible }) => (isVisible ? "visible" : "hidden")};
	}
`

const enhance = compose(
	withState("isVisible", "setVisible", false),
	withHandlers({
		onScrollChange: ({ elementRef, setVisible }) => () =>
			setVisible(get(elementRef, "scrollTop") > 0),
		onClick: ({ elementRef }) => () => set(elementRef, "scrollTop", 0)
	}),
	lifecycle({
		componentDidMount() {
			if (this.props.elementRef !== undefined) {
				this.props.elementRef.addEventListener("scroll", this.props.onScrollChange)
			}
		},
		componentDidUpdate(prevProps) {
			if (prevProps.elementRef !== undefined) {
				this.props.elementRef.removeEventListener("scroll", this.props.onScrollChange)
			}
			if (this.props.elementRef !== undefined) {
				this.props.elementRef.addEventListener("scroll", this.props.onScrollChange)
			}
		},
		componentWillUnmount() {
			if (this.props.elementRef !== undefined) {
				this.props.elementRef.removeEventListener("scroll", this.props.onScrollChange)
			}
		}
	})
)

export default enhance(ScrollUpButton)



// WEBPACK FOOTER //
// ./src/components/scroll-up-button/ScrollUpButton.js